import { ScheduledEmail } from './types';

const cloneDeep = require('lodash.clonedeep');

const mutations = {
  setEmailTypes(state, { emailTypes }: { emailTypes: ScheduledEmail[] }) {
    state.emailTypes = emailTypes;
  },
  updateEmailSchedule(state, emailTypes: ScheduledEmail[]) {
    const keyValue = {};
    emailTypes.forEach(elm => {
      keyValue[elm.id] = elm;
    });
    const tempStateEmailTypes = [] as ScheduledEmail[];
    state.emailTypes.forEach(elm => {
      let tempElm = {} as ScheduledEmail;
      if (keyValue[elm.id]) {
        tempElm = { ...elm, active: keyValue[elm.id].active };
      } else {
        tempElm = elm;
      }
      tempStateEmailTypes.push(cloneDeep(tempElm));
    });
    state.emailTypes = tempStateEmailTypes;
  },
  setLoadingEmailTypesList(state, loadingEmailTypesList: boolean) {
    state.loadingEmailTypesList = loadingEmailTypesList;
  },
  setLoadingBulkUpdate(state, loadingBulkUpdate: boolean) {
    state.loadingBulkUpdate = loadingBulkUpdate;
  },
  updateEmailConfig(state, { emailConfig }: { emailConfig: ScheduledEmail }) {
    const tempEmailTypes = state.emailTypes.slice(0);
    tempEmailTypes.forEach((element, index) => {
      if (element.id === emailConfig.id) {
        tempEmailTypes[index] = emailConfig;
      }
    });
    state.emailTypes = tempEmailTypes;
  },
  setLoadingUpdateEmailType(state, loading: boolean) {
    state.loadingUpdateEmailType = loading;
  },
  setLoadingSendTestEmail(state, loading: boolean) {
    state.loadingSendTestEmail = loading;
  },
  setLoadingSendCustomEmail(state, loading: boolean) {
    state.loadingSendCustomEmail = loading;
  },
  setEmailInEdit(state, emailConfig: ScheduledEmail | undefined) {
    if (emailConfig === undefined) {
      state.emailInEdit = emailConfig;
    } else {
      state.emailInEdit = JSON.parse(JSON.stringify(emailConfig));
    }
  },
  updateEmailInEdit(state, payload) {
    if (!state.emailInEdit) {
      return;
    }
    state.emailInEdit = { ...state.emailInEdit, ...payload };
  },
  setEmailTypesFor(state, emailTypesFor: string) {
    state.emailTypesFor = emailTypesFor;
  },
  updateWaitlistEmailSchedule(state) {
    state.emailTypes.forEach(elm => {
      if (elm.email_type === 'Waitlist') {
        elm.active = true;
      }
    });
  },
  deleteEmailConfig(state, { id }: { id: string }) {
    state.emailTypes = state.emailTypes.filter(elm => elm.id !== id);
  }
};

export default mutations;
